import React, {useEffect} from "react";
import CompanyPageContainer from "./Company.style";
import CompanyDatatable from "./components/CompanyDatatable/CompanyDatatable";
import useController from "./Company.controller";
import {withRouter} from "react-router-dom";
import {Button, Card} from "antd";
import PlusOutlined from "@ant-design/icons/es/icons/PlusOutlined";
import {useThemeSelector} from "../../redux/reducers/themeReducer";
import CompanyList from "./components/CompanyList/CompanyList";
import CompanyDetailsDrawer from "./components/CompanyDetailsDrawer/CompanyDetailsDrawer";

const Company = ({history}) => {
    const {primaryColor, darkMode} = useThemeSelector();
    const {companies, loading, getCompanies, setAddCompanyClicked, onEditClick, onDeleteClick, onLicencesClick,
        companyDetailsVisible, companyToShowDetailsFor, toggleCompanyDetails, onRemoveProductFromCompany, isDeviceSmall} = useController({history});

    useEffect(() => {
        getCompanies();
    }, []);

    return <CompanyPageContainer>

        <Card title='Companies'>

            <Button key="3" type="primary" onClick={setAddCompanyClicked}>
                <PlusOutlined/>
                Add
            </Button>

        {isDeviceSmall ?
            <CompanyList onEditClick={onEditClick} onDeleteClick={onDeleteClick} onLicencesClick={onLicencesClick}
                         data={companies} loading={loading} primaryColor={primaryColor}
                         toggleCompanyDetails={toggleCompanyDetails} companyDetailsVisible={companyDetailsVisible} /> :

            <CompanyDatatable onEditClick={onEditClick} onDeleteClick={onDeleteClick} onLicencesClick={onLicencesClick}
                              toggleCompanyDetails={toggleCompanyDetails} companyDetailsVisible={companyDetailsVisible} companyToShowDetailsFor={companyToShowDetailsFor}
                              data={companies} loading={loading} primaryColor={primaryColor} onRemoveProductFromCompany={onRemoveProductFromCompany}/>
        }

        </Card>

        <CompanyDetailsDrawer darkMode={darkMode} companyToShowDetailsFor={companyToShowDetailsFor} companyDetailsVisible={companyDetailsVisible}
                              toggleCompanyDetails={toggleCompanyDetails} />

    </CompanyPageContainer>
};

export default withRouter(Company);